export default function useLanguage() {
  let lang = localStorage.getItem("lang");
  return { language: lang || "ar" };
}
